export default {
    buttons: {
        add_location: 'Добавить местоположение',
    },
    fields: {
        name: {
            label: 'Название услуги',
            placeholder: 'Введите название услуги',
        },
        company: {
            label: 'Компания (необязательно)',
            placeholder: 'Выберите',
        },
        location: {
            label: 'Местоположение услуги',
            placeholder: 'Выберите',
        },
        description: {
            label: 'Описание',
            placeholder: 'Опишите вашу услугу...',
        },
        appointment_length: {
            label: 'Продолжительность приема',
            placeholder: 'Выберите',
        },
        price: {
            label: 'Цена',
            placeholder: 'Введите',
        },
        currency: {
            label: 'Валюта',
            placeholder: 'EUR/RDS',
        },
        category: {
            label: 'Категория',
            placeholder: 'Выберите',
        },
        subcategory: {
            label: 'Подкатегория',
            placeholder: 'Выберите',
        },
        default_calendar_event_status: {
            label: 'Хотите автоматически принимать бронирования на эту услугу?',
        },
        public_reservation: {
            label: 'Заблокировать публичное бронирование?',
        },
        reservation_in_advance: {
            label: 'Разрешить бронирование заранее',
            placeholder: 'Выберите',
            tooltip:
                'За сколько времени заранее вы разрешаете клиентам бронировать запись? Например, 60 минут означает, что клиент не сможет забронировать запись, которая начинается менее чем через час.',
        },
        cancellation_in_advance: {
            label: 'Разрешить отмену заранее',
            placeholder: 'Выберите',
            tooltip:
                'Зa сколько времени заранее вы разрешаете клиентам отменять запись? Например, 60 минут означает, что клиент не сможет отменить запись, которая начинается менее чем через час.',
        },
        rescheduling_in_advance: {
            label: 'Разрешить перенос заранее',
            placeholder: 'Выберите',
            tooltip:
                'Зa сколько времени заранее вы разрешаете клиентам переносить запись? Например, 60 минут означает, что клиент не сможет перенести запись, которая начинается менее чем через час.',
        },
        pause: {
            label: 'Длительность паузы (Мин)',
            placeholder: 'Введите',
            tooltip:
                'Введите желаемую продолжительность перерыва или периода неактивности (в минутах). Ваше время в календаре будет разделено на интервалы по указанному количеству минут. Минимальная продолжительность — 15 минут, максимальная — 180 минут.',
        },
        reservation_type: {
            label: 'Тип бронирования',
            placeholder: 'Выберите',
            tooltip:
                'Одобрение - вы вручную принимаете бронирования; Автоматически - бронирования принимаются автоматически; Блокировка - только вы можете создавать бронирования для себя; Регос - технические осмотры.',
        },
    },
    reservation_type: {
        request_approval: 'Одобрение бронирований',
        accepted_by_default: 'Автоматически принятые бронирования',
        block_public_reservations: 'Блокировка публичных бронирований',
        external_system_regos: 'Regos - внешняя система',
        request_service: 'Запрос услуги бронирования',
    },

    header: 'Введите категорию',
    table: {
        title: 'Название',
        price: 'Цена',
        length: 'Продолжительность',

        description: 'Описание',
        actions: 'Действия',
    },
    errors: {
        location: {
            company_has_no_locations: 'У этой компании нет местоположений',
        },
        category: {
            warning: 'Чтобы ваша услуга была видимой, вам необходимо добавить хотя бы одну категорию!',
        },
    },
}
